import TransformComponent from '../../../Component/Transform';
import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import Interactable from '../../../Component/Interactable';
import CardSystem, { getCardHandler } from '../../Card/CardSystem';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import { StartAudio } from '../../Audio/AudioHelper';
import {
    AUDIO_CARD_STREAK_1,
    AUDIO_CARD_STREAK_10,
    AUDIO_CARD_STREAK_2,
    AUDIO_CARD_STREAK_3,
    AUDIO_CARD_STREAK_4,
    AUDIO_CARD_STREAK_5,
    AUDIO_CARD_STREAK_6,
    AUDIO_CARD_STREAK_7,
    AUDIO_CARD_STREAK_8,
    AUDIO_CARD_STREAK_9,
} from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';
import { showCardScoreEffectAt } from '../CardAnimationHelper';

interface ICardMatchMetaData {
    system: CardSystem;
    cardScore: number;
}

export class CardMatch extends AnimationClip {
    public *execute(
        card: BaseCard,
        meta: ICardMatchMetaData
    ): IterableIterator<number> {
        let streakAudioIndex = meta.system.state.getState().levelState
            .cardsState.streakSequence;
        if (streakAudioIndex > 10) {
            streakAudioIndex = 10;
        }

        StartAudio(
            meta.system.scene,
            [
                AUDIO_CARD_STREAK_1,
                AUDIO_CARD_STREAK_2,
                AUDIO_CARD_STREAK_3,
                AUDIO_CARD_STREAK_4,
                AUDIO_CARD_STREAK_5,
                AUDIO_CARD_STREAK_6,
                AUDIO_CARD_STREAK_7,
                AUDIO_CARD_STREAK_8,
                AUDIO_CARD_STREAK_9,
                AUDIO_CARD_STREAK_10,
            ][streakAudioIndex - 1],
            AudioTrackType.SFX
        );

        const handler = getCardHandler(card);
        handler.setCardFaceUp(true);
        handler.setCardModifiersVisible(false);

        // Add to stack container maintaining previous global position.
        meta.system.stackContainer.addChild(card);

        const transform: TransformComponent = card.getComponent(
            TransformComponent
        );
        const interactable = card.getComponent(Interactable);
        interactable.enabled = false;

        showCardScoreEffectAt(
            meta.system.scene,
            card.parent,
            meta.cardScore,
            transform.position.clone()
        );

        // Fix scale in case interrupting flip animation.
        transform.scale.set(1, 1);

        const arcYPosition = transform.y - 100;

        const tweenX = this.getTween(transform.position);
        const tweenYIN = this.getTween(transform.position);
        const tweenYOUT = this.getTween(transform.position);
        const tweenRotation = this.getTween(transform);

        tweenX.to({ x: 0 }, 1000);
        tweenX.easing(Easing.Quadratic.Out);

        tweenYIN.to({ y: arcYPosition }, 500);
        tweenYIN.easing(Easing.Quadratic.Out);

        tweenRotation.to({ rotation: Math.PI * 4 }, 1000);
        tweenRotation.easing(Easing.Cubic.Out);

        tweenX.start(this.elapsedTime);
        tweenRotation.start(this.elapsedTime);

        yield* this.startTween(tweenYIN);

        tweenYOUT.to({ y: 0 }, 500);
        tweenYOUT.easing(Easing.Quadratic.In);

        yield* this.startTween(tweenYOUT);
    }
}
